import React, { useMemo } from "react";
import { Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import { useQuery } from "react-query";
import { Spin, Tag } from "antd";
import "../../Styles/style.css";
import TableContainerMin from "../../../Components/Common/TableContainer";
import { getOldDriverVehicle } from "../../Users/services/userApi";

const OldDriver = ({ user }) => {
    
  const vehId = user?.vehicle?.id
  const {
    data: oldDriver,
    isLoading,
    isError,
    error,
  } = useQuery(["oldDriver", vehId], () => getOldDriverVehicle(vehId),
  {
    enabled: !!vehId,
  });
  console.log('driver',oldDriver )
  
  const columns = useMemo(
    () => [
        { 
            Header: "Nom", 
            accessor: "name",
            filterable: false 
        },
        { Header: "Adresse email", accessor: "email", filterable: false },
        { Header: "Téléphone", accessor: "phone", filterable: false },
        { Header: "Status", accessor: "status", filterable: false },
    ],
    []
  );

  return (
    <Card id="contactList">
      <CardHeader>
        Liste des anciens chauffeurs de ce vehicule <Tag color="cyan">{user?.vehicle?.brand || "-"}</Tag>
      </CardHeader>
      <CardBody className="pt-0">
        <TableContainerMin
          columns={columns}
          data={oldDriver || []}
          isGlobalSearch={true}
          isGlobalFilter={true}
          customPageSize={5}
          className="custom-header-css"
          divClass="table-responsive table-card mb-3"
          tableClass="align-middle table-nowrap"
          theadClass="table-light"
        />
        {isLoading && !isError && (
          <div className="text-center">
            Chargement... <Spin />
          </div>
        )}
        {oldDriver && oldDriver.length === 0 && !isLoading && (
          <div>Erreur lors du chargement, {error || error?.message}</div>
        )}
      </CardBody>
    </Card>
  );
};

export default OldDriver;
